<div class="sw-cms-preview-block-moorl-grid-layout-six">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>